import { Box } from "@mui/material";
import PractitionerSidebar from "components/PractitionerSidebar";
import PracDashboardWalkthrough from "components/UI/PracDashboardWalkthrough";
import { Outlet } from "react-router-dom";

export default function PractitionerMainLayout() {
  return (
    <Box>
      <PracDashboardWalkthrough />
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "228px 1fr", lg: "265px 1fr" },
          minHeight: "calc(100vh - 70px - 60px)",
          mt: "70px",
          mb: "60px",
        }}
      >
        <Box sx={{ borderRight: "1px solid #e9e9ef" }}>
          <PractitionerSidebar />
        </Box>
        <Box
          sx={{
            px: { xs: "1rem", lg: "2rem" },
            py: { xs: ".5rem", lg: "1rem" },
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
